<template>
</template>

<script>
import {mapGetters} from 'vuex';
import jwtDecode from '../../mixins/jwt-decoder/jwt-decode';

export default {
    name: 'google-one-tap',
    data() {
        return {
            googleOptions: {
                client_id: process.env.MIX_GOOGLE_CLIENT_ID,
                auto_select: false,
                cancel_on_tap_outside: false,
                context: 'signin'
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn'])
    },
    created() {
        this.init();
    },
    methods: {
        googleOneTap({client_id, auto_select = false, cancel_on_tap_outside = false, context = 'signin'}, callback) {
            const contextValue = ['signin', 'signup', 'use'].includes(context) ? context : 'signin';
            let googleScript = document.createElement('script');
            googleScript.onload = function () {
                if (client_id) {
                    window.google.accounts.id.initialize({
                        client_id: client_id,
                        callback: callback,
                        auto_select: auto_select,
                        cancel_on_tap_outside: cancel_on_tap_outside,
                        context: contextValue
                    });
                    window.google.accounts.id.prompt();
                } else {
                    console.error('client_id is missing for Google One-Tap!');
                }
            };
            googleScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
            document.head.appendChild(googleScript);
        },
        init() {
            if (!this.isLoggedIn && this.$route.name) {
                this.googleOneTap(this.googleOptions, (response) => {
                    axios.post('/auth/google', {
                        googleOneTap: true,
                        serviceAccount: jwtDecode(response.credential),
                    }).then(response => {
                        if (response.data.status === 200) {
                            this.$store.dispatch('auth/socialLogin', {
                                token: response.data.token,
                                user: response.data.user
                            });
                        }
                    }).catch(err => {
                        console.error({err: err})
                    });
                });
            }
        }
    },
    watch: {
        // [Nick] We have to remove Google One-Tap modal after logging in
        isLoggedIn: {
            handler(val) {
                if (val) {
                    let el = document.getElementById('credential_picker_container');
                    if (el) {
                        el.remove();
                    }
                } else {
                    this.init();
                }
            }
        }
    }
}
</script>
